import React, {useEffect, useState} from "react";
import ResultOrShoqa from "./_ResultOrShoqa";
import queryString from "query-string";
import RowPhoto from "../../common/TdImg";
import db from "../../../services/query";
import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import PrintTable from "../common/PrintTable";

const DisqualifiedStudents = (props) => {
    const {isShoqa, title, chance} = props;

    const [data, setData] = useState([]);

    let titles = [
        title ?? '',
        `${data?.summary?.class_desc} | ${data?.summary?.entry_year}`,
        data?.summary?.title,
        data?.summary?.teacher_name,
    ]

    let printHeadTexts = [
        "معاونیت امور محصلان",
        data?.summary?.faculty_name
    ];

    const renderResult = (state) => {
        switch (state) {
            case 0:
                return "ناکام";
            case 1:
                return "کامیاب";
            case 3:
                return "محروم";
        }
    };

    const columns = [
        {path: "id", label: "شماره"},
        {
            path: "student_photo",
            label: "عکس",
            content:({student_photo}) => <RowPhoto src={student_photo}/>,
        },
        {path: "student_name", label: "نام"},
        {path: "student_father_name", label: "نام پدر"},
        {path: "absent_count", label: "غیرحاضر"},
        {path: "absent_percentage", label: "فیصدی"},
        {
            path: "result",
            label: "نتیجه",
            content: ({result}) => renderResult(result),
        }
    ];


    useEffect(() => {
        requestData();

        return () => setData([]);
    }, []);

    const requestData = async (p = {}) => {
        const {classId, subjectId, entryYearId} = props.match.params;

        try {
            let query = `results/classes/${classId}/${subjectId}?&entryYearId=${entryYearId}`;

            await db.getAll(query).then(({data}) => {
                data.data = data.data.filter((result) => result.result === 3);
                console.log(data)
                setData(data);
            });

        } catch ({response}) {
            setData(response);
        }
    };

    return (
        <main className="main-print-wrapper no-table-footer shoqa">
            <PrintHeader
                titles={titles}
                printHeadTexts={printHeadTexts}
                changeableDate={isShoqa}
                date={isShoqa ? "" : "  "}
            />
            <PrintBodyTitle title={[]}/>
            <PrintTable columns={columns} data={data}/>

            <div style={{display: "grid", gridTemplateColumns: "auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "40%"}}>
                            <hr/>
                            <p> امضاء آمر دپارتمنت</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "40%"}}>
                            <hr/>
                            <p>امضاء استاد</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default DisqualifiedStudents;
